<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 3: General Contractor
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <d-field label="General Contractor Name">
        <d-input v-model="generalContractorName" aria-label="General contractor name" required />
      </d-field>

      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="City" class="w-full md:w-1/2 px-5">
          <d-input v-model="generalContractorCity" aria-label="City" required />
        </d-field>
        <d-field label="State/Province" class="w-full md:w-1/2 px-5">
          <d-input v-model="generalContractorStateProvince" aria-label="state / province" required />
        </d-field>
      </div>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_CERTIFICATION_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('projectCertificationForm');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['generalContractorName', 'generalContractorCity', 'generalContractorStateProvince'],
        module: 'projectCertificationForm',
        base: 'formFields',
        mutation: PROJECT_CERTIFICATION_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>